/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	jQuery('#specialists_carousel').owlCarousel({
		loop:false,
		margin:30,
		nav:false,
		dots:true,
		autoplay:true,
		autoplayTimeout:15000,
		responsive:{
			0:{
				items:1
			},
			300:{
				items:1
			},
			600:{
				items:2
			},
			900:{
				items:3
			},
			1200:{
				items:3
			},
			1440:{
				items:3
			}
		}
	});

	var owl = jQuery('#testimonials_carousel').owlCarousel({
		loop:false,
		margin:30,
		nav:false,
		dots:true,
		autoplay:true,
		autoplayTimeout:15000,
		responsive:{
			0:{
				items:1
			},
			300:{
				items:1
			},
			600:{
				items:2
			},
			900:{
				items:2
			},
			1200:{
				items:3
			},
			1440:{
				items:3
			}
		}
	});

	owl.on('translated.owl.carousel', function() {
		new Foundation.Equalizer(jQuery("#testimonials_carousel")).applyHeight();
	}).trigger('translated.owl.carousel');

	jQuery('.wpcf7 select option').first().attr('disabled', 'disabled');
});